import { FunctionComponent } from 'react';

import Table from './Table';
import Tabs from './Tabs';
import useSearchResults from './useSearchResults';

const SearchResults: FunctionComponent = () => {
  const { hasFetched, tabs, index, onTabClick } = useSearchResults();
  console.log({ tabs, index });
  if (!hasFetched) return null;
  return (
    <div className="flex flex-col flex-1 w-full">
      <Tabs tabs={tabs} index={index} onTabClick={onTabClick} />
      <Table index={index} />
    </div>
  );
};

export default SearchResults;
